import React from "react";
import { QuotesHeader } from "../../components/Headers/Headers";
import PageName from "../../components/react_helmet/PageName";
import QuotesTable from "../../components/table/QuotesTable";
import useQuotes from "./customHooks/useQuotes";
import TableSkeleton from "../../components/skeleton/TableSkeleton";
const Quotes = () => {
  const {
    searchValue,
    setSearchValue,
    quotes,
    selectedData,
    setSelectedData,
    status,
    setStatus,
    user,
    page,
    setPage,
    pageSize,
    setPageSize,
    loading,
    totalPages,
    gettingQuotes
  } = useQuotes();

  return (
    <div className="settings-container">
      <PageName title={"Quotes"} />
      <div className="px-4">
        <QuotesHeader
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          status={status}
          setStatus={setStatus}
          user={user}
          data={quotes}
          loading={loading}
          setPage={setPage}
          gettingQuotes={gettingQuotes}
          totalCount={totalPages}
        />

        <div className="settings-card">
          {loading ? (
            <TableSkeleton columns={7} />
          ) : (
            <QuotesTable
              data={quotes}
              searchValue={searchValue}
              setSelectedData={setSelectedData}
              user={user}
              page={page}
              totalPages={totalPages}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              onClearSearch={searchValue ? () => {
                setSearchValue("");
                setPage(1);
              } : undefined}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Quotes;
